<template>
  <el-dialog
    title="添加开户行"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose">
    <el-form :model="addAccountBankInfo" :rules="rules" ref="addForm" label-width="100px">
      <el-form-item label="银行账号" prop="bankCode">
        <el-input 
          v-model="addAccountBankInfo.bankCode" 
          placeholder="必填，请填写银行账号"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="持卡人" prop="personName">
        <el-input 
          v-model="addAccountBankInfo.personName" 
          placeholder="必填，请填写持卡人"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="personTel">
        <el-input 
          v-model="addAccountBankInfo.personTel" 
          placeholder="选填，请填写手机号"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bankName">
        <el-input 
          v-model="addAccountBankInfo.bankName" 
          placeholder="必填，请填写开户行"
          clearable>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveAccountBankInfo">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveAccountBank } from '@/api/goods/accountBankApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddAccountBank',
  data() {
    return {
      dialogVisible: false,
      addAccountBankInfo: {
        bankCode: '',
        personName: '',
        personTel: '',
        bankName: '',
        shopId: ''
      },
      rules: {
        bankCode: [
          { required: true, message: '银行账号不能为空', trigger: 'blur' },
          { max: 20, message: '银行账号不能超过20个字符', trigger: 'blur' }
        ],
        personName: [
          { required: true, message: '持卡人不能为空', trigger: 'blur' },
          { max: 20, message: '持卡人名称不能超过20个字符', trigger: 'blur' }
        ],
        personTel: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '开户行不能为空', trigger: 'blur' },
          { max: 100, message: '开户行名称不能超过100个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.clearAddAccountBankInfo()
    },
    saveAccountBankInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addAccountBankInfo.shopId = getShopId()
          saveAccountBank(this.addAccountBankInfo)
            .then(response => {
              this.$message.success('添加成功')
              this.dialogVisible = false
              this.$emit('refresh')
            })
            .catch(error => {
              this.$message.error(error.message || '添加失败')
            })
        }
      })
    },
    clearAddAccountBankInfo() {
      this.addAccountBankInfo = {
        bankCode: '',
        personName: '',
        personTel: '',
        bankName: '',
        shopId: ''
      }
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate()
      })
    },
    handleClose() {
      this.$refs.addForm.resetFields()
    }
  }
}
</script>